/* KIWABI / Accessible swipe carousel for Global, India and China mobile editions.
 * Desktop and Japanese product carousel remain unchanged.
 */
(()=>{'use strict';
  const mq=window.matchMedia('(max-width:700px)');
  const active=new Map();
  let seq=0;
  const selectors='.kw-site:not(.kw-japan) .kr-series-grid, .kw-site.kw-china .kc-products';
  function setup(track) {
    if(active.has(track))return;
    const cards=[...track.children].filter(el=>el.matches('.kr-series,.kc-product'));
    if(cards.length<2)return;
    const chinese=!!track.closest('.kw-china');
    const prevId=track.getAttribute('id'),prevRole=track.getAttribute('role');
    const prevLabel=track.getAttribute('aria-label'),prevDesc=track.getAttribute('aria-roledescription');
    if(!prevId)track.id='KWIRegionSlider'+(++seq);
    track.setAttribute('role','region');
    track.setAttribute('aria-roledescription','carousel');
    track.setAttribute('aria-label',chinese?'ROOT VANISH 与 ROOT BEAUTÉ 护理系列':'ROOT VANISH and ROOT BEAUTÉ care series');
    const div=document.createElement('div');
    div.className='kw-region-slider-controls';
    div.setAttribute('role','group');
    div.setAttribute('aria-label',chinese?'系列浏览控制':'Series carousel controls');
    const hint=document.createElement('span');
    hint.className='kw-region-slider-hint';
    hint.textContent=chinese?'左右滑动，探索系列':'Swipe to explore the series';
    const count=document.createElement('span');
    count.className='kw-region-slider-count';
    count.setAttribute('aria-live','polite');
    const back=document.createElement('button'),forward=document.createElement('button');
    back.type=forward.type='button';
    back.textContent='←';forward.textContent='→';
    back.setAttribute('aria-label',chinese?'上一个系列':'Previous series');
    forward.setAttribute('aria-label',chinese?'下一个系列':'Next series');
    back.setAttribute('aria-controls',track.id);
    forward.setAttribute('aria-controls',track.id);
    div.append(hint,back,count,forward);
    track.insertAdjacentElement('afterend',div);
    const span=()=>{
      if(cards.length<2)return track.clientWidth;
      return Math.max(1,Math.abs(cards[1].offsetLeft-cards[0].offsetLeft));
    };
    const current=()=>Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/span())));
    const refresh=()=>{
      const i=current();
      count.textContent=(i+1)+' / '+cards.length;
      back.disabled=i===0;
      forward.disabled=i===cards.length-1;
    };
    const go=(delta)=>{
      const i=Math.max(0,Math.min(cards.length-1,current()+delta));
      track.scrollTo({left:i*span(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    const backAction=()=>go(-1),forwardAction=()=>go(1);
    back.addEventListener('click',backAction);
    forward.addEventListener('click',forwardAction);
    track.addEventListener('scroll',refresh,{passive:true});
    active.set(track,()=>{
      back.removeEventListener('click',backAction);
      forward.removeEventListener('click',forwardAction);
      track.removeEventListener('scroll',refresh);
      div.remove();
      track.scrollLeft=0;
      for(const [key,old] of [['role',prevRole],['aria-label',prevLabel],['aria-roledescription',prevDesc],['id',prevId]]){
        if(old===null)track.removeAttribute(key);else track.setAttribute(key,old);
      }
    });
    refresh();
  }
  function sync(){
    if(!mq.matches){
      for(const teardown of active.values())teardown();
      active.clear();
      return;
    }
    for(const [node,teardown] of [...active]){
      if(!node.isConnected){teardown();active.delete(node);}
    }
    document.querySelectorAll(selectors).forEach(setup);
  }
  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('shopify:section:unload',()=>queueMicrotask(sync));
  if(mq.addEventListener)mq.addEventListener('change',sync);else mq.addListener(sync);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
})();
